const api = `${process.env.VUE_APP_URL}/ServicosExternos/`;

export const conteudo = id => fetch(`${api}BeneficiarioEmpresa.ashx?func=BuscaConteudos&empresa=${id}`)
  .then(res => res.json())
  .then(data => data.conteudos);
export const login = id => fetch(`${api}BeneficiarioEmpresa.ashx?func=VerificaEmpresa&carteirinha=${id}`)
  .then(res => res.text());
